<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4"></div>
    </base-header>

    <!--Board items-->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <board-items-table :board_id="id" :board="board" :board_items="items"></board-items-table>
        </div>
      </div>
    </div>
    <!-- End board-->

    <div style="position: fixed; width: 200px; z-index: 1051; top: 90px; right: 30px;" v-if="is_still_loading">
      <el-alert show-icon effect="dark" title="Loading data" type="warning" :closable="false"
        style="justify-content: space-around;">{{ loaded_tasks }} / {{
          total_tasks
        }} records</el-alert>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import BoardItemsTable from "./BoardItemsTable";

import {
  Alert,
  Spinner
} from "element-ui";

function getBoardItems(id, page_cursor = null) {
  return store.dispatch("monday/list_board_items", { id, page_cursor });
}

export default {
  props: ["id"],
  components: {
    BoardItemsTable,
    [Alert.name]: Alert,
    [Spinner.name]: Spinner,
  },
  data() {
    return {
      loader: null,
      mini_dash_data: [],
      total_tasks: 0,
      loaded_tasks: 0,
      board: {},
      items: [],
      is_still_loading: false,
    };
  },
  created() {
    getBoardItems(this.id).then(() => {
      this.groupData();
    });
  },
  computed: {
    board_items() {
      return store.state.monday.board_items;
    },
  },
  methods: {
    groupData() {
      if (this.board_items && this.board_items.length > 0) {
        let items = this.board_items[0].items;
        this.loaded_tasks = items.length;
        this.total_tasks = this.board_items[0].total_items;

        items = items.map((item) => {
          if (!item.has_read) {
            item.has_read = false;
          }
        });

        this.board = this.board_items;
        this.items = _.groupBy(_.clone(items), "group.id");

        if (this.board_items[0].page_cursor) {
          this.is_still_loading = true;

          getBoardItems(this.id, this.board_items[0].page_cursor).then(() => {
            this.groupData();
          });
        } else {
          this.is_still_loading = false;
        }
      } else {
        this.board = this.board_items;
        this.items = [];
      }
    },
  },
  watch: {
    $route(to, from) {
      getBoardItems(to.params.id).then(() => this.groupData());
    },
  },
};
</script>
<style lang="scss" scoped>
.checkmark {
  font-size: 16rem;
  opacity: 0.3;
}
</style>
